const svgToDataUri = (svg: string) =>
  `data:image/svg+xml,${encodeURIComponent(svg)}`;

const prevIconSvg =
  '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.96796 12.5724L1.63062 6.79061L7.96796 1.00879" stroke="#6C757D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const nextIconSvg =
  '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.59844 12.5724L7.93579 6.79061L1.59844 1.00879" stroke="#6C757D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

const calendarStyles = {
  ".fc-scrollgrid ": { color: "#6E6B7B", borderRadius: "0px 0px 6px 6px" },
  ".fc .fc-scrollgrid-section, .fc .fc-scrollgrid-section table, .fc .fc-scrollgrid-section > td ":
    {
      borderRadius: "0px 0px 6px 6px",
    },
  ".fc .fc-button-primary:not(:disabled).fc-button-active": {},
  "& .fc .fc-button": { textTransform: "none" },
  ".fc-event": {
    borderTop: "none !important",
    borderBottom: "none !important",
    borderRight: "none !important",
  },
  "& .fc-header-toolbar": {
    padding: { xs: "10px", sm: "10px 20px" },
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "1px solid",
    borderRight: "1px solid",
    borderLeft: "1px solid",
    borderColor: "#E9EAEC",
    marginBottom: "0 !important",
    borderRadius: "6px 6px 0px 0px",
  },
  "& .fc-toolbar-chunk:first-of-type": {
    marginRight: "auto",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  "& .fc-toolbar-chunk:last-child": {
    marginLeft: "auto",
  },
  "& .fc-prev-button": {
    backgroundImage: `url("${svgToDataUri(prevIconSvg)}")`,

    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundColor: "transparent",
    width: { xs: "9px", sm: "30px" },
    height: { xs: "14px", sm: "30px" },
    border: "none",
    padding: "0",
    textIndent: "-9999px",
    overflow: "hidden",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&:focus": {
      boxShadow: "none !important",
    },
    "&:active": {
      backgroundColor: "transparent !important",
      borderColor: "transparent !important",
    },
  },
  "& .fc-next-button": {
    backgroundImage: `url("${svgToDataUri(nextIconSvg)}")`,
    marginLeft: " 20px !important",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundColor: "transparent",
    width: { xs: "9px", sm: "30px" },
    height: { xs: "14px", sm: "30px" },
    border: "none",
    padding: "0",
    textIndent: "-9999px",
    overflow: "hidden",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&:focus": {
      boxShadow: "none !important",
    },
    "&:active": {
      backgroundColor: "transparent !important",
      borderColor: "transparent !important",
    },
  },
  "& .fc-dayGridMonth-button, & .fc-timeGridWeek-button, & .fc-timeGridDay-button":
    {
      backgroundColor: "#fff",
      color: "#4467A4",
      border: "1px solid #4467A4",
      "&.fc-button-active": {
        backgroundColor: "#4467A4 !important",
        color: "#fff !important",
        borderColor: "#4467A4 !important",
      },
      "&:focus": {
        boxShadow: "none !important",
      },
      "&:hover": {
        backgroundColor: "#4467A4 !important",
        borderColor: "#4467A4 !important",
      },
    },
  "& .fc-toolbar-title": {
    fontSize: { xs: "14px", sm: "18px" },
    color: "#5E5873",
    textTransform: "capitalize",
    marginLeft: "20px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: { xs: "130px", sm: "300px" },
  },
  "& .fc-day-today": {
    backgroundColor: "#F8F8F8 !important",
  },
  "& .fc-daygrid-event-harness": {
    borderRadius: "5px",
  },
  "& .fc-more-popover": {
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.15))",
    backgroundColor: "#fff",
  },
  "& .fc-more-popover .fc-popover-header": {
    backgroundColor: "#fff",
    padding: "8px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "8px",
  },
  "& .fc-more-popover .fc-popover-title": {
    fontSize: "14px",
    color: "#5E5873",
  },
  "& .fc-more-popover .fc-popover-close": {
    fontSize: "16px",
    cursor: "pointer",
    color: "#5E5873",
    "&:hover": {
      color: "#000",
    },
  },
  "& .fc-more-popover .fc-popover-body": {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: "8px 12px",
  },
  "& .fc-event": {
    borderRadius: "4px !important",
    marginLeft: "2px !important",
    marginRight: "2px !important",
    cursor: "pointer !important",
  },
  "& .fc-more-popover .fc-event": {
    textDecoration: "none",
    borderTop: "none !important",
    borderBottom: "none !important",
    borderRight: "none !important",
    width: "100%",
    "& .fc-event-main": {
      padding: "2px 6px",
    },
    "& .fc-event-title": {
      fontSize: "12px",
      fontWeight: 500,
    },
  },
  "& .fc-viewSelector-button": {
    fontSize: { xs: "14px", sm: "16px" },
    height: { xs: "34px", sm: "auto" },
    p: { xs: "8px 12px", sm: "8px 16px" },
    bgcolor: "transparent",
    borderRadius: "8px",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    color: "#707070",
    display: "flex",
    alignItems: "center",
    textTransform: "none",
    "&.fc-button-active, &:hover": {
      bgcolor: "transparent !important",
      color: "rgba(0, 0, 0, 0.23) !important",
      border: "1px solid rgba(0, 0, 0, 0.23) !important",
    },
    "&.fc-button-active, &:focus": {
      boxShadow: "none !important",
    },
    "&.fc-icon-up::after": {
      content: '"\\25B2"',
      fontSize: "12px",
      ml: "4px",
      display: "inline-block",
      verticalAlign: "middle",
    },
    "&.fc-icon-down::after": {
      content: '"\\25BC"',
      fontSize: "12px",
      ml: "4px",
      display: "inline-block",
      verticalAlign: "middle",
    },
  },
};

export default calendarStyles;
